import React from 'react';
import { TopToolbar } from 'react-admin';
import ConfirmInvoiceButton from './ConfirmInvoiceButton';

const InvoiceShowActions = ({ data }) => (
	<TopToolbar>
		{data && <ConfirmInvoiceButton record={data} />}
	</TopToolbar>
);

export default InvoiceShowActions;
